<div class="ipm-whatsapp-verification-section">
    <div class="ipm-heading-model-section">
        <h3>{{ heading }}</h3>
        <div class="ipm-close-icon" (click)="closeByDeviceType()">
            <i class="pi pi-times"></i>
        </div>
    </div>

    <div class="ipm-whatsapp-body">
        <p class="ipm-wall-message">{{ wallMessage }}</p>

        <div class="error-message-data" *ngIf="errorMessage">
            {{ errorMessage }}
        </div>

        <div class="success-message-data" *ngIf="successMessage">
            {{ successMessage }}
        </div>

        <ng-container *ngIf="!isOtpStep; else otpStepTemplate">
            <div class="custom-form m-0">
                <div class="form-group custom-form-group mobile-number ipm-icon-more">
                    <label aria-label="Mobile Number">{{ label }}<sup>*</sup></label>
                    <div class="ipm-mobile-view-section">
                        <div class="mobile-number-input position-relative">
                            <div class="ipm-country-code">
                                <p-dropdown [className]="'ipm-dropdown'" [autoDisplayFirst]="false"
                                    [options]="countryListArray" name="countryCode" id="countryCode"
                                    [(ngModel)]="selectedCountry" [required]="true" [filter]="true"
                                    panelStyleClass="ipm-dark-dropdown"
                                    filterBy="isoCode,dialCode" optionLabel="dialCode">
                                    <ng-template let-selectedCountryData pTemplate="selectedItem">
                                        <div class="d-flex align-items-center gap-2" *ngIf="selectedCountryData">
                                            <img [src]="'./assets/countries/countries-flags/'+selectedCountryData?.isoCode+'.png'"
                                                [class]="'flag flag-' + selectedCountryData.code" style="width: 18px" />
                                            <div>{{ selectedCountryData.dialCode }}</div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-country pTemplate="item">
                                        <div class="d-flex align-items-center gap-2">
                                            <img [src]="'./assets/countries/countries-flags/'+country?.isoCode+'.png'"
                                                [class]="'flag flag-' + country.code" style="width: 18px" />
                                            <div style="white-space: nowrap;">{{ country.dialCode }} ({{ country?.isoCode | uppercase }})</div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                            <input type="text"
                                class="form-control padding-mobile-number"
                                name="mobileNumber"
                                [(ngModel)]="mobileNumber"
                                (keypress)="formService.keyPressNumber($event)"
                                (ngModelChange)="onMobileNumberChange($event)"
                                maxlength="15"
                                required>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ipm-actions">
                <button mat-flat-button
                    color="primary"
                    class="primary-button ipm-submit-btn"
                    type="button"
                    (click)="sendOtp()"
                    [disabled]="isSendingOtp || !mobileNumber">
                    {{ isSendingOtp ? 'Sending...' : 'Send OTP' }}
                </button>
            </div>
        </ng-container>

        <ng-template #otpStepTemplate>
            <p class="ipm-sub-heading">
                {{ subHeading }}
                <b>{{selectedCountry?.dialCode}} {{mobileNumber}}</b>
            </p>

            <div class="custom-form m-0">
                <div class="form-group custom-form-group mb-0">
                    <input type="text"
                        class="form-control handle-text-box"
                        id="otpMobile"
                        name="otpMobile"
                        [ngModel]="otpCode"
                        (ngModelChange)="updateOtpCode($event)"
                        (keypress)="formService.keyPressNumber($event)"
                        required>
                </div>
            </div>

            <div class="ipm-send-Verification">
                <span>{{countdown === 0 ? 'Didn’t receive the code?' : 'You can resend the OTP in'}}
                    <button (click)="resendOtp()" type="button" class="pl-0" *ngIf="countdown === 0">Resend</button>
                    <span *ngIf="countdown !== 0" class="count-text">{{countdown}} Sec</span>
                </span>
            </div>

            <div class="ipm-edit-number">
                <button type="button" (click)="editNumber()">Edit number</button>
            </div>

            <div class="ipm-actions">
                <button mat-flat-button
                    color="primary"
                    class="primary-button ipm-submit-btn"
                    type="button"
                    (click)="verifyOtp()"
                    [disabled]="isVerifyingOtp || !otpCode || isOtpLocked">
                    {{ isVerifyingOtp ? 'Verifying...' : 'Verify' }}
                </button>
            </div>
        </ng-template>
    </div>
</div>
